module.exports = __webpack_public_path__ + "img/nfts-fill.ab761f54.svg";